module.exports = __webpack_public_path__ + "static/media/quotesTile.f6e71823.jpg";